// @ts-nocheck
const UserProps = [
	{
		id: "lastName",
		title: "Nom",
		visible: true,
	},
	{
		id: "firstName",
		title: "Prénom",
		visible: true,
	},
	{
		id: "login",
		title: "Login",
		visible: true,
	},
	{
		id: "role",
		title: "Role",
		visible: true,
	},
	{
		id: "companyId",
		title: "CompanyId",
		role: "EloAdmin",
	},
	{
		id: "siteName",
		title: "Site",
		visible: true,
	},
	{
		id: "siteId",
		title: "Identifiant du site",
		role: "EloAdmin",
	},
	{
		id: "employeeId",
		title: "Identifiant de l'utilisateur",
		visible: true,
	},
	{
		id: "workFamilyName",
		title: "Famille",
		visible: true,
	},
	// {
	// 	id: "WorkFamillyId",
	// 	title: "WorkFamillyId",
	// 	role: "EloAdmin"
	// },
	{
		id: "workFunctionName",
		title: "Fonction",
		visible: true,
	},
	// {
	// 	id: "WorkFunctionId",
	// 	title: "WorkFunctionId",
	// 	role: "EloAdmin"
	// },
	// {
	// 	id: "Display_Mail",
	// 	title: "Visibilité du mail",
	// 	visible: true
	// },
	// {
	// 	id: "Display_Phone",
	// 	title: "Visibilité du téléphone",
	// 	visible: true
	// },
	{
		id: "mail",
		title: "Mail",
		visible: true,
	},
	{
		id: "phone",
		title: "Telephone",
		visible: true,
	},
	// {
	// 	id: "FirstConnexion",
	// 	title: "Première connexion",
	// 	visible: true,
	// },
	{
		id: "lastConnexion",
		title: "Dernière connexion",
		visible: true,
	},
	// {
	// 	id: "HiredDate",
	// 	title: "HiredDate",
	// 	visible: false,
	// },
	// {
	// 	id: "Hobby",
	// 	title: "Hobby",
	// 	visible: true,
	// },
	// {
	// 	id: "IsVisibleInApp",
	// 	title: "IsVisibleInApp",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "LanguageId",
	// 	title: "LanguageId",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "LastChange_AuthorId",
	// 	title: "LastChange_AuthorId",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "LastChanged",
	// 	title: "LastChanged",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "Sex",
	// 	title: "Sex",
	// 	visible: false,
	// },
	// {
	// 	id: "Token_Regeneration",
	// 	title: "Token_Regeneration",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "AspNetUserId",
	// 	title: "AspNetUserId",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "ByPass_Moderation",
	// 	title: "ByPass_Moderation",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "CompanyRankId",
	// 	title: "CompanyRankId",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "UserTemplateId",
	// 	title: "UserTemplateId",
	// 	role: "EloAdmin",
	// },
	// {
	// 	id: "Workplace",
	// 	title: "Workplace",
	// 	visible: false,
	// },
];

export const getUserProps = (isSup) => {
	return UserProps.filter(
		(a) => a.visible !== false && (!a.role || (isSup && isSup(a.role) >= 0))
	);
};

export default UserProps;
